import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from './slices/user/userSlice';
import forgotPassReducer from './slices/auth/forgotPassSlice';
import profileReducer from './slices/user/profileSlice';
import searchReducer from './slices/search/searchSlice';
import loginReducer from './slices/auth/loginSlice';
import dashboardReducer from './slices/dashboard/dashboardSlice';
import homeReducer from './slices/home/homeSlice';
import tableSortValuesReducer from './slices/tableSortValues/tableSortValues.slice';
import repaymentReducer from './slices/repayment/repaymentSlice';
import referralReducer from './slices/referral/referralSlice';
import walletReducer from './slices/wallet/walletSlice';
import rentPaymentReducer from './slices/rentPayment/rentPaymentSlice';
import passwordResetReducer from './slices/passwordReset/passwordResetSlice';
import onboardingReducer from './slices/onboarding/onboardingSlice';
import apartmentSearchReducer from './slices/apartmentSearch/apartmentSearchSlice';
import creditReportReducer from '../features/creditReport/creditReportSlice';
import rewardReducer from './slices/reward/rewardSlice';
import billPaymentReducer from './slices/billPayment/billPaymentSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    forgotPassModal: forgotPassReducer,
    userProfile: profileReducer,
    globalSearch: searchReducer,
    login: loginReducer,
    dashboard: dashboardReducer,
    home: homeReducer,
    tableSortValues: tableSortValuesReducer,
    repayment: repaymentReducer,
    referral: referralReducer,
    wallet: walletReducer,
    rentPayment: rentPaymentReducer,
    passwordReset: passwordResetReducer,
    onboarding: onboardingReducer,
    apartmentSearch: apartmentSearchReducer,
    reward: rewardReducer,
    creditReport: creditReportReducer,
    billPayment: billPaymentReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['bills/setBillSuccessData'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.subtitle.$$typeof'],
        // Ignore these paths in the state
        ignoredPaths: ['bills.billSuccessData.subtitle']
      }
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
